import { GetPortalsForEmail } from '../../Services/Tenant';
import { LogException } from '../../Utils/Logging';
import {
    AppThunkActionAsync
} from '../index';
import { KnownAction as uiKnownActions, actionCreators as uiStateActions } from '../UIState';
import {
    KnownAction,
    MultiTenantActions,
} from './Actions';

const GetAvailablePortalsForEmail = (email: string, externalId: string): AppThunkActionAsync<void, KnownAction | uiKnownActions> =>
    async (dispatch, getState): Promise<void> => {
        const workingName = `get-portals-for-email`;

        dispatch(uiStateActions.SetPortalWorking(workingName));

        try {
            dispatch({
                type: MultiTenantActions.MultiTenantLoadPortals,
                email,
                externalId,
            })

            const tenantsResult = await GetPortalsForEmail(email, externalId);

            dispatch({
                type: MultiTenantActions.MultiTenantLoadPortalsComplete,
                email,
                externalId,
                tenantsResult,
            });
        } catch (e) {
            const errorMsg = 'Listing portals for email address failed';

            console.error(errorMsg);
            console.error(e);

            LogException(errorMsg, e);

            dispatch({
                type: MultiTenantActions.MultiTenantLoadPortalsComplete,
                email,
                externalId,
                undefined,
            })
        } finally {
            dispatch(uiStateActions.SetPortalIdle(workingName));
        }
    }


export const actionCreators = {
    GetAvailablePortalsForEmail,
};
